/** @format */
import React, { useState, useContext, useEffect } from 'react'
import { _$, Select, Option, Form, FormItem } from '@king-design/react'
import styled from 'styled-components'
import { useLocation } from 'react-router'
import MonitorSearch from 'src/components/MonitorSearch'
import { CountContext } from 'src/pages/EventCenter'
import { EventOptions } from 'src/pages/EventCenter/constants'

function useQuery() {
  return new URLSearchParams(useLocation().search)
}

const EventCenter: React.FC<{ className?: string }> = ({ className }) => {
  const params = useQuery()
  const fixedProduct = params.get('fixedProduct')
  const { eventOptions, filterValues, setFilterValue, query, setQuery } = useContext(CountContext)
  const [eventTypeOptions, setEventTypeOptions] = useState<EventOptions[]>([])
  const [eventNameOptions, setEventNameOptions] = useState<EventOptions[]>([])

  useEffect(() => {
    if (eventOptions?.length) {
      productTypeChange(filterValues.NamespaceId)
    }
  }, [eventOptions, filterValues.NamespaceId])
  // 产品类型change
  const productTypeChange = value => {
    const findProduct = eventOptions.find(item => item.value === value)
    setEventTypeOptions(findProduct?.children || [])
  }

  // 事件类型change
  const eventTypeChange = value => {
    const { NamespaceId } = filterValues
    const findProduct = eventOptions.find(item => item.value === NamespaceId)
    if (findProduct) {
      const findEventType = findProduct.children.find(item => item.value === value)
      setEventNameOptions(findEventType?.children || [])
    }
    setFilterValue({
      ...filterValues,
      EventType: value,
      Name: ''
    })
  }

  // 事件名称change
  const eventNameChange = value => {
    setFilterValue({
      ...filterValues,
      Name: value
    })
  }

  return (
    <div className={className}>
      <div className="filter">
        <div className="form-item">
          <Form layout="inline">
            <FormItem label={_$('产品类型')}>
              <Select
                width={200}
                clearable={true}
                disabled={!!fixedProduct}
                value={filterValues.NamespaceId}
                onChangeValue={value => {
                  setFilterValue({
                    NamespaceId: value,
                    EventType: '',
                    Name: ''
                  })
                }}
              >
                {eventOptions.map(({ label, value }) => (
                  <Option key={value} value={value}>
                    {label}
                  </Option>
                ))}
              </Select>
            </FormItem>
            <FormItem label={_$('事件类型')}>
              <Select
                width={200}
                clearable={true}
                value={filterValues.EventType}
                onChangeValue={eventTypeChange}
              >
                {eventTypeOptions.map(({ label, value }) => (
                  <Option key={value} value={value}>
                    {label}
                  </Option>
                ))}
              </Select>
            </FormItem>
            <FormItem label={_$('事件名称')}>
              <Select
                width={200}
                clearable={true}
                value={filterValues.Name}
                onChangeValue={eventNameChange}
              >
                {eventNameOptions.map(({ label, value }) => (
                  <Option key={value} value={value}>
                    {label}
                  </Option>
                ))}
              </Select>
            </FormItem>
            <FormItem label={_$('搜索')}>
              <MonitorSearch
                placeholder={_$('输入关键词搜索')}
                value={query}
                onChange={val => setQuery(val)}
              />
            </FormItem>
          </Form>
        </div>
      </div>
    </div>
  )
}
export default styled(EventCenter)`
  .filter {
    display: flex;
    margin-top: 16px;
    align-items: center;
    justify-content: space-between;
    .form-item {
      display: flex;
      align-items: center;
      p {
        padding-right: 5px;
        margin: 0;
      }
      .k-form-item {
        margin: 0 16px 16px 0;
      }
    }
  }
`
